import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, } from '@mui/material';
import { useRef, useState } from 'react';
import I18N from '@/components/I18N';
const useConfirm = () => {
    const [open, setOpen] = useState(false);
    const resolver = useRef({});
    const createPromise = () => new Promise(r => (resolver.current.resolve = r));
    const getConfirmation = async () => {
        setOpen(true);
        return await createPromise();
    };
    const ConfirmationDialog = ({ children, title, cancelProps, confirmProps, dialogProps, }) => {
        const handleClose = (confirmation) => {
            resolver.current.resolve?.(confirmation);
            setOpen(false);
        };
        return (_jsx(Dialog, { "data-label": "dialog-screen", "data-testid": "confirmation-dialog", onClose: () => handleClose(false), ...dialogProps, open: open, children: _jsxs("div", { className: "dialog-box", children: [_jsx(DialogTitle, { children: title }), _jsx(DialogContent, { children: children }), _jsxs(DialogActions, { children: [_jsx(Button, { "data-label": "cancel", "data-testid": "cancel-button", onClick: () => handleClose(false), children: _jsx(I18N, { children: "common.cancel" }), ...cancelProps }), _jsx(Button, { "data-label": "primary", "data-testid": "confirm-button", onClick: () => handleClose(true), children: _jsx(I18N, { children: "common.confirm" }), ...confirmProps })] })] }) }));
    };
    return { getConfirmation, ConfirmationDialog };
};
export default useConfirm;
